import {resources} from "../../../../../../../core/models/resource/resources";

export const declarationResourceType = resources['declarations'];
export const declarationFilesResourceType = resources['declaration-files'];
